export const HERO_DESKTOP_MEDIA = "(min-width: 768px) and (orientation: landscape)";

export type HeroConnection = {
  saveData?: boolean;
  effectiveType?: string;
  downlink?: number;
};

export function allowsHeroVideo(reducedMotion: boolean, connection?: HeroConnection) {
  if (reducedMotion || connection?.saveData) return false;
  if (["slow-2g", "2g", "3g"].includes(connection?.effectiveType ?? "")) return false;
  if (connection?.downlink !== undefined && connection.downlink < 1.5) return false;
  return true;
}

export function shouldPlayHeroVideo(loaded: boolean, allowed: boolean, inView: boolean, visible: boolean) {
  return loaded && allowed && inView && visible;
}